// citationParser.js — browser-safe, no Node built-ins
const norm = (s) => s.replace(/[‐-―]/g, "-");

const parseDocType = (s) =>
  /\b10-?K\b|annual report/i.test(s)
    ? "annual"
    : /proxy statement|\bDEF\s*14A\b/i.test(s)
      ? "proxy"
      : /\bS-1(?:\/A)?\b|registration statement|initial report/i.test(s)
        ? "initial"
        : null;

const parseYear = (s) => {
  const m = s.match(/\b(19|20)\d{2}\b/);
  return m ? Number(m[0]) : null;
};

function parsePages(s) {
  const pages = new Set();
  const re = /\bpp?\.?\s*(\d+(?:\s*-\s*\d+)?(?:\s*,\s*\d+(?:\s*-\s*\d+)?)*)/gi;
  let m;
  let citationSplit = "";
  while ((m = re.exec(norm(s)))) {
    if (!citationSplit) {
      citationSplit = m[0].split(",")?.[0];
    }
    for (const part of m[1].split(",")) {
      const rng = part.trim().match(/^(\d+)\s*-\s*(\d+)$/);
      if (rng) {
        const a = +rng[1],
          b = +rng[2];
        for (let i = Math.min(a, b); i <= Math.max(a, b); i++) pages.add(i);
      } else {
        const n = parseInt(part, 10);
        if (!Number.isNaN(n)) pages.add(n);
      }
    }
  }
  return { pages: [...pages].sort((a, b) => a - b), citationSplit };
}

export function parseCitation(raw) {
  const docType = parseDocType(raw);
  const year = parseYear(raw);
  const pageDetails = parsePages(raw);
  const pages = pageDetails?.pages;
  const citationSplit = pageDetails?.citationSplit;
  const splitCitation = citationSplit ? raw.split(citationSplit)[0] : raw;
  let status, reason;
  if (!docType || !year) {
    status = "quarantined";
    reason = !docType ? "unknown docType" : "no year";
  } else if (pages.length === 0) {
    status = "document";
  } else {
    status = "page";
  }
  return {
    docType,
    year,
    pages,
    splitCitation,
    status,
    ...(reason ? { reason } : {}),
  };
}

export function parseRecord(rec) {
  return {
    raw: rec.citation,
    cik: rec.cik,
    ticker: rec.ticker,
    companyName: rec.companyName,
    ...parseCitation(rec.citation),
    collection: rec.collection,
    path: rec.path,
    sourceId: rec.sourceId,
  };
}
